import Vue from 'vue'

/**
 * https://www.npmjs.com/package/vue-countup-v2
 * https://github.com/xlsdg/vue-countup-v2
 */
Vue.component('ICountUp', () => import('vue-countup-v2'))
